<template>
  <div>
    <div class="banner">
      <h1>购票须知</h1>
    </div>
    <div class="container">
      <Card shadow :padding="68">
        <img src="@/assets/border-img-t-l.png" alt="" class="border-img border-top-left">
        <img src="@/assets/border-img-t-r.png" alt="" class="border-img border-top-right">
        <img src="@/assets/border-img-b-l.png" alt="" class="border-img border-bottom-left">
        <img src="@/assets/border-img-b-r.png" alt="" class="border-img border-bottom-right">
<!--        <div class="title">-->
<!--          <h1>购票须知</h1>-->
<!--        </div>-->
        <div v-html="data" style="padding: 0 36px;"></div>
      </Card>
    </div>
  </div>
</template>

<script>
// import Instructions from '../../../mock/Instructions.json'
import { httpAction } from '@/api/manage'
import api from '@/api'
export default {
  data () {
    return {
      // Instructions,
      data: ''
    }
  },
  mounted () {
    this.getInstructions()
  },
  methods: {
    getInstructions () {
      httpAction(api.noticeList, 'post',{type:4}).then(res => {
        this.data = res.data.noticeListVO[0].content
      })
    }
  }
}
</script>

<style scoped>
.container{
  margin: 220px 0 20px;
}
.title{
  text-align: center;
}
.banner{
  background-image: url("../../../assets/banner_3.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 1920px;
}
</style>
